import * as Constants from '../common/constants';
export const lightTheme = {
    background: Constants.COLOR.AQUA_GREEN100,
    color: '#000000',
    linkFontColor: '#666',
    mode: 'light',
};
export const darkTheme = {
    background: '#040507',
    color: '#f0f5fa',
    linkFontColor: '#fff',
    mode: 'dark',
};
export function getTheme(colorMode) {
    switch (colorMode) {
        case 'light':
            return lightTheme;
        case 'dark':
            return darkTheme;
        default:
            return lightTheme;
    }
}
